import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AqiCalenderViewComponent } from './aqi-calender-view/aqi-calender-view.component';
import { SharedModule } from '../shared/shared.module';
import { SharedFilterModalModule } from '../shared/shared-filter-modal/shared-filter-modal.module';
import { FormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

@NgModule({
  declarations: [AqiCalenderViewComponent],
  imports: [
    CommonModule,
    SharedModule,
    SharedFilterModalModule,
    FormsModule,
    NgbModule,
  ],
  exports: [AqiCalenderViewComponent]
})
export class CommonComponentsModule { }
